import { render, staticRenderFns } from "./provideOrganizationInfoSecond.vue?vue&type=template&id=665ffcb7&scoped=true&"
import script from "./provideOrganizationInfoSecond.vue?vue&type=script&lang=js&"
export * from "./provideOrganizationInfoSecond.vue?vue&type=script&lang=js&"
import style0 from "./provideOrganizationInfoSecond.vue?vue&type=style&index=0&id=665ffcb7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665ffcb7",
  null
  
)

export default component.exports